function encode(data) {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

export async function sendContactForm(data) {
    return new Promise((resolve, reject) => {
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": data.formName, ...data })
        })
            .then(() => {
                resolve()
            })
            .catch(err => {
                reject(err)
            })
    })
}